import styled from 'styled-components';
import { respondTo } from 'assets/styled/breakpoints';
import { COLORS, marginMd, marginSm } from 'assets/styled';

export const Form = styled.form`
  max-width: 100%;
  width: 100%;
`;

export const InputWrapper = styled.div`
  margin-bottom: ${marginSm};
  position: relative;
  width: 580rem;

  ${respondTo.bigPhone`
    width: 100%;
    max-width: 100%;
  `}
`;

export const EyeWrapper = styled.div`
  cursor: pointer;
  height: fit-content;
  user-select: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20rem;
  width: 100%;
  margin: ${marginMd} 0;
`;

export const ForgotPasswordWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const ForgotPasswordLabel = styled.label`
  font-size: 16rem;
  font-weight: 400;
  line-height: 25rem;
  color: ${COLORS.GREEN};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  ${respondTo.smallPhone`
    font-size: 14rem;
    text-align: end;
  `}
`;
